module.exports = __webpack_public_path__ + "img/P150T_weapon_65.21458da8.png";